module.exports = __webpack_public_path__ + "img/start_m.a000b858.png";